<div *transloco="let t" class="flex w-full flex-col gap-2 p-2">
  <app-dsp-audience-warning [audiences]="resolvedAudiences()" />
  <div
    class="flex h-[35rem] border"
    [ngClass]="{
      'rounded-md': style() === 'rounded',
      'border-l-0': style() === 'outlined',
      'border-r-0': style() === 'outlined',
    }"
    cdkDropListGroup
  >
    <div class="flex h-full min-w-0 flex-1 basis-0 flex-col border-r border-gray-200">
      <div class="z-10 flex w-full gap-2 border-b border-gray-200 p-4">
        <div iInputGroup>
          <IIcon name="search" />
          <input
            iInputGroupInput
            [placeholder]="t('common.search')"
            size="sm"
            class="flex-1"
            [ngModel]="searchFilter()"
            (ngModelChange)="onSearch($event)"
          />
        </div>
        <IMultiSelectMenu [value]="selectedCategoryOptions()" (valueChange)="categoryFilterChange($event)" class="w-48">
          <ISelectTrigger>
            <ISelectValue [placeholder]="t('common.select')">
              <div class="truncate" *iSelectValue="let value">
                {{ t("common.selected", { count: value.length }) }}
              </div>
            </ISelectValue>
          </ISelectTrigger>
          <ISelectContent>
            @for (option of audienceCategoryOption; track option.value) {
              <ISelectOption [value]="option">
                {{ option.label }}
              </ISelectOption>
            }
          </ISelectContent>
        </IMultiSelectMenu>
      </div>

      <div class="flex flex-1 flex-col overflow-y-auto" cdkDropList>
        @for (audience of paginatedDspAudiences(); track audience.audienceId) {
          @let isAudienceSelectable = audience | isAudienceSelectable;
          <div
            [iTooltip]="
              isAudienceSelectable
                ? audience.audienceName
                : t('dsp-create-strategy-page.you_cannot_use_this_audience', { status: audience.status })
            "
          >
            <app-dsp-audience-line
              cdkDrag
              [ngClass]="{ disabled: !isAudienceSelectable }"
              [cdkDragData]="audience"
              (cdkDragStarted)="startDrag(audience)"
              (cdkDragEnded)="endDrag()"
              (click)="clickOnAudience(audience)"
              [audience]="audience"
            >
              <app-dsp-audience-line *cdkDragPlaceholder [audience]="audience" [isPlaceholder]="true" />
              <app-dsp-audience-line
                class="w-[30rem] rounded-sm shadow-md"
                *cdkDragPreview
                [audience]="audience"
                [isDragPreview]="true"
              />
            </app-dsp-audience-line>
          </div>
        } @empty {
          <div class="mt-5 text-center text-gray-700">
            {{ t("dsp-create-strategy-page.no_matching_audience_found") }}
          </div>
        }
      </div>
      <div class="h-16 border-t">
        @if (filteredDspAudiences().length > DEFAULT_PAGE_SIZE) {
          <IPaginator
            [length]="filteredDspAudiences().length"
            [pageIndex]="pagination().pageIndex"
            [pageSize]="DEFAULT_PAGE_SIZE"
            (paginationEvent)="pagination.set($event)"
            [displayPageSizeOptions]="false"
          />
        }
      </div>
    </div>
    <div class="flex min-w-0 flex-1 basis-0 flex-col">
      <div class="border-b px-5 py-5.5 font-medium">
        {{
          audienceType() === StrategyDspAudienceType.WHITELIST
            ? t("dsp-create-strategy-page.selected_audiences")
            : t("dsp-audiences-selector.audiences_to_blacklist")
        }}
      </div>
      <div class="relative h-full overflow-y-scroll px-5 py-5">
        @if (audienceType() === StrategyDspAudienceType.WHITELIST) {
          @for (
            selectedAudienceGroup of resolvedAudiences();
            track selectedAudienceGroup;
            let groupIndex = $index;
            let first = $first
          ) {
            <div class="mt-2 flex flex-col">
              @if (!first) {
                <IBadge [label]="t('common.and') | titlecase" color="gray" class="my-4" />
              }
              <div class="rounded border">
                <div class="flex justify-between border-b p-2 text-sm font-medium text-gray-700">
                  <span>{{
                    first
                      ? t("dsp-audiences-selector.target_people_matching")
                      : t("dsp-audiences-selector.and_must_also_match")
                  }}</span>
                  @if (groupIndex > 0) {
                    <button iButton variant="ghost" size="sm" (click)="removeGroup(groupIndex)">
                      <IIcon name="trash" />
                    </button>
                  }
                </div>
                <div class="relative">
                  @let audienceBeingDraggedAlreadyInGroup =
                    audienceBeingDragged() && (audienceBeingDragged()! | isInAudienceGroup: selectedAudienceGroup);
                  <div
                    class="relative min-h-24 pb-12 transition"
                    [ngClass]="audienceBeingDragged() ? 'bg-gray-50 shadow-inner' : ''"
                    cdkDropList
                    (cdkDropListDropped)="drop($event, groupIndex)"
                    (cdkDropListEntered)="draggingHoverGroup.set(groupIndex)"
                    (cdkDropListExited)="draggingHoverGroup.set(undefined)"
                  >
                    @for (
                      selectedAudience of selectedAudienceGroup;
                      track selectedAudience.audienceId;
                      let audienceIndex = $index
                    ) {
                      <app-dsp-audience-line
                        [audience]="selectedAudience"
                        [isInAudienceGroup]="true"
                        [isLastInGroup]="audienceIndex === selectedAudienceGroup.length - 1"
                        (clicked)="deleteAudience(groupIndex, audienceIndex)"
                        [isReadOnly]="false"
                      >
                      </app-dsp-audience-line>
                    }

                    @if (
                      draggingHoverGroup() !== groupIndex &&
                      !audienceBeingDraggedAlreadyInGroup &&
                      selectedAudienceGroup.length < MAX_AUDIENCE_PER_GROUP
                    ) {
                      <div
                        class="absolute w-full"
                        [ngClass]="selectedAudienceGroup.length === 0 ? 'bottom-12' : 'bottom-1'"
                      >
                        <div class="flex h-12 w-full items-center justify-center gap-2 text-gray-700">
                          <IIcon name="dragDrop" class="text-xl" />
                          <span class="text-sm">{{ t("dsp-create-strategy-page.drop_audience_here") }}</span>
                        </div>
                      </div>
                    }
                  </div>
                  @if (audienceBeingDraggedAlreadyInGroup) {
                    <div
                      class="absolute top-0 z-20 flex h-full w-full items-center justify-center bg-gray-100/90 text-sm font-medium"
                    >
                      {{ t("dsp-create-strategy-page.audience_already_in_group") }}
                    </div>
                  } @else if (audienceBeingDragged() && selectedAudienceGroup.length >= MAX_AUDIENCE_PER_GROUP) {
                    <div
                      class="absolute top-0 z-20 flex h-full w-full items-center justify-center bg-gray-100/90 text-sm font-medium"
                    >
                      {{ t("dsp-audiences-selector.you_have_reached_the_maximum_number_of_audiences_in_this_group") }}
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        } @else {
          @for (selectedAudienceGroup of resolvedAudiences(); track selectedAudienceGroup; let groupIndex = $index) {
            <div class="mt-2 flex flex-col">
              @for (selectedAudience of selectedAudienceGroup; track selectedAudience.audienceId; let index = $index) {
                <app-dsp-audience-line
                  [audience]="selectedAudience"
                  [isInAudienceGroup]="true"
                  [isLastInGroup]="true"
                  (clicked)="deleteAudience(groupIndex, index)"
                  [isReadOnly]="false"
                >
                </app-dsp-audience-line>
              }
            </div>
          }
          @if (selectedAudiences().length === 0 || selectedAudiences()[0].length < MAX_AUDIENCE_PER_GROUP) {
            <div
              class="min-h-24 pb-12 transition"
              [ngClass]="audienceBeingDragged() ? 'bg-gray-50 shadow-inner' : ''"
              cdkDropList
              (cdkDropListDropped)="drop($event, 0)"
              (cdkDropListEntered)="draggingHoverGroup.set(0)"
              (cdkDropListExited)="draggingHoverGroup.set(undefined)"
            ></div>
            @if (!audienceBeingDragged()) {
              <div class="w-full">
                <div class="flex h-12 w-full items-center justify-center gap-2 text-gray-700">
                  <IIcon name="dragDrop" class="text-xl" />
                  <span class="text-sm">{{ t("dsp-audiences-selector.drop_an_audience_here_to_blacklist_it") }}</span>
                </div>
              </div>
            }
          }
        }

        @if (
          selectedAudiences().length < MAX_AUDIENCE_GROUP_PER_STRATEGY &&
          audienceType() === StrategyDspAudienceType.WHITELIST
        ) {
          <div class="mt-6">
            <button iButton variant="secondary" size="sm" (click)="addAudienceGroup()">
              <IIcon name="plus" />
              {{ t("dsp-audiences-selector.reach_more_specific_users") }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
